package br.com.texeratx.boardgametimeapp.ui.screens.reset_password

import br.com.texeratx.boardgametimeapp.core.i18n.LanguageManager
import br.com.texeratx.boardgametimeapp.domain.usecases.login.ResetPasswordUseCase
import br.com.texeratx.boardgametimeapp.ui.screens.login.LoginScreen
import cafe.adriel.voyager.core.model.ScreenModel
import cafe.adriel.voyager.core.model.screenModelScope
import cafe.adriel.voyager.navigator.Navigator
import io.github.aakira.napier.Napier
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.launch

class ResetPasswordViewModel(
    private val resetPasswordUseCase: ResetPasswordUseCase,
    private val lang: LanguageManager
) : ScreenModel {

    var state = MutableStateFlow(ResetPasswordUiState())
        private set

    fun initEmail(email: String) {
        if (email.isNotBlank()) {
            state.value = state.value.copy(email = email)
        }
    }

    fun updateEmail(v: String) {
        state.value = state.value.copy(email = v)
    }

    fun updateCode(v: String) {
        // Aceita apenas dígitos, máximo 6
        val digits = v.filter { it.isDigit() }.take(6)
        state.value = state.value.copy(code = digits)
    }

    fun updateNewPassword(v: String) {
        state.value = state.value.copy(newPassword = v)
    }

    fun updateConfirmPassword(v: String) {
        state.value = state.value.copy(confirmPassword = v)
    }

    fun submit(navigator: Navigator) {
        screenModelScope.launch {
            val s = state.value

            if (s.email.isBlank()) {
                state.value = s.copy(error = lang.strings.value.emailRequired)
                return@launch
            }
            if (s.code.length != 6) {
                state.value = s.copy(error = lang.strings.value.codeMustBe6Digits)
                return@launch
            }
            if (s.newPassword.isBlank()) {
                state.value = s.copy(error = lang.strings.value.newPasswordRequired)
                return@launch
            }
            if (s.newPassword != s.confirmPassword) {
                state.value = s.copy(error = lang.strings.value.passwordsDoNotMatch)
                return@launch
            }

            state.value = s.copy(isLoading = true, error = null)

            val result = resetPasswordUseCase(s.email.trim(), s.code, s.newPassword)

            result.fold(
                onSuccess = {
                    Napier.d("ResetPasswordViewModel → senha redefinida com sucesso")
                    state.value = state.value.copy(isLoading = false)
                    navigator.replaceAll(LoginScreen())
                },
                onFailure = { e ->
                    Napier.e("ResetPasswordViewModel → erro", e)
                    state.value = state.value.copy(
                        isLoading = false,
                        error = e.message ?: lang.strings.value.invalidOrExpiredCode
                    )
                }
            )
        }
    }
}
